// extracted by mini-css-extract-plugin
export default {"card":"MapCard_card__xoP0m","map":"MapCard_map__jxvlW","controlsBox":"MapCard_controlsBox__ZqQIA","link":"MapCard_link__dCSMd"};